<template>
  <div>
    <LoadingWidget v-if="loading" />

    <transition name="fade">
      <v-sheet
        v-if="!loading && items.length"
        class="py-10 py-md-13 py-lg-16 position-relative slides"
        color="#FBF9F4"
      >
        <TitleWidget class="text-center item-title-widget" bottom>
          Avaliações dos Clientes
        </TitleWidget>

        <hooper-container
          class="slides-container"
          style="height: auto"
          ref="carousel"
          :wheelControl="false"
          :mouseDrag="items.length > 1"
          :touchDrag="items.length > 1"
          :infiniteScroll="items.length > 1"
          @slide="updateCarousel"
        >
          <hooper-slide
            class="d-flex align-center justify-center"
            v-for="(item, keySlide) in items"
            :key="keySlide"
          >
            <v-sheet
              class="mx-auto pa-5 position-relative"
              max-width="680px"
              color="transparent"
            >
              <TestimonialCard class="item" v-bind="item" />
            </v-sheet>
          </hooper-slide>
        </hooper-container>

        <div
          v-if="items.length > 1"
          class="d-flex justify-space-between px-3 px-md-4 px-lg-5 slides-nav"
        >
          <a
            class="d-flex align-center justify-center pr-1 slides-nav-item"
            @click.prevent="slidePrev"
          >
            <v-icon color="#808080" :size="xsOnly ? 30 : 40">
              fa-angle-left
            </v-icon>
          </a>
          <a
            class="d-flex align-center justify-center pl-1 slides-nav-item"
            @click.prevent="slideNext"
          >
            <v-icon color="#808080" :size="xsOnly ? 30 : 40">
              fa-angle-right
            </v-icon>
          </a>
        </div>
      </v-sheet>
    </transition>
  </div>
</template>

<script>
import LoadingWidget from "../widgets/LoadingWidget.vue";
import TitleWidget from "../widgets/TitleWidget.vue";
import TestimonialCard from "../cards/TestimonialCard.vue";

const _config = {
  mod: "testimonials",
};

export default {
  data: () => ({
    loading: true,
    carouselData: 0,
  }),
  created() {
    this.$rest(_config.mod)
      .get()
      .then(() => (this.loading = false));
  },
  computed: {
    items() {
      return this.$rest(_config.mod).list;
    },
    xsOnly() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  methods: {
    slidePrev() {
      this.$refs.carousel.slidePrev();
    },
    slideNext() {
      this.$refs.carousel.slideNext();
    },
    updateCarousel(payload) {
      this.myCarouselData = payload.currentSlide;
    },
  },
  watch: {
    carouselData() {
      this.$refs.carousel.slideTo(this.carouselData);
    },
  },
  components: {
    LoadingWidget,
    TitleWidget,
    TestimonialCard,
  },
};
</script>

<style lang="scss" scoped>
.slides {
  .item {
    margin-top: 120px;

    &:before,
    &:after {
      content: "";
      background-repeat: no-repeat;
      background-size: contain;
      height: 36px;
      left: 0;
      pointer-events: none;
      position: absolute;
      right: 0;
    }

    &:before {
      background-image: url(../../assets/img/testimonials-top-left.png),
        url(../../assets/img/testimonials-top-right.png);
      background-position: left center, right center;
      top: 0;
    }

    &:after {
      background-image: url(../../assets/img/testimonials-bottom-left.png),
        url(../../assets/img/testimonials-bottom-right.png);
      background-position: left center, right center;
      bottom: 0;
    }
  }

  &-nav {
    height: 0;
    left: 0;
    margin-top: -25px;
    position: absolute;
    top: 50%;
    width: 100%;

    @media screen and (max-width: 600px) {
      margin-top: -20px;
    }

    &-item {
      border-radius: 50%;
      height: 50px;
      width: 50px;
      @media screen and (max-width: 600px) {
        height: 40px;
        width: 40px;
      }
    }
  }
}

.slides {
  .item-title-widget {
    left: 0;
    margin-top: 80px;
    position: absolute;
    right: 0;
    top: 0;
  }
}

.slides-container::v-deep {
  ol,
  ul {
    padding-left: 0 !important;
  }

  .hooper-track {
    transition: transform 0s 0.5s !important;
  }

  .hooper-slide,
  .hooper-slide.is-prev,
  .hooper-slide.is-next {
    transition: opacity 1s 0s;
    opacity: 0 !important;
  }

  .hooper-slide.is-active {
    transition-delay: 0.5s;
    opacity: 1 !important;
  }
}
</style>
